export default (state = {
    keyword: '',
    products: [],
    category: [],
    breadcrumb: [],
    fetchingProducts: false,
    fetched: false,
    has_more: true,
    is_loading: true,
    pagination: {
        count: 0,
        scroll_id: '',
    }

}, action) => {
    switch (action.type) {
        case 'UPDATE_CATEGORIES_LIST_BREADCRUMB' :
            return {
                ...state,
                selectedCategory: action.results,
            };

        case 'UPDATE_CATEGORY_PRODUCTS_KEYWORD' :
            return {
                ...state,
                keyword: action.keyword,
                // products: [],
                // has_more: false,
                // is_loading: false,
            };

        case 'RESET_CATEGORY_PRODUCTS_SEARCH' :
            return {
                ...state,
                products: [],
                fetched: false,
                pagination: {
                    count: 0,
                    scroll_id: '',
                }
            };
        case 'FETCHING_CATEGORY_PRODUCTS_SEARCH' :
            return {
                ...state,
                fetchingProducts: true,
                is_loading: true,
            };
        case 'FETCH_CATEGORY_PRODUCTS_SEARCH' :
            return {
                ...state,
                products: state.products.concat(action.results.results),
                category: action.results.category[0] || [],
                pagination: action.results.pagination,
                fetchingProducts: false,
                fetched: true,
                has_more: action.results.pagination.count > 0 ? true :  false,
                is_loading: false,
            };
        case 'FETCHING_CATEGORY_PRODUCTS_SEARCH_FAILED' :
            return {
                ...state,
                fetched: 0,
                fetchingProducts: 0,
            };

        default:
            return state;
    }
};
